/**
 * Login API
 * 로그인 관련 API 호출 함수
 */

import { apiClient } from '../../../core/api/client';
import { LoginRequest, LoginResponse, SupplierLoginResponse } from '../types/login';

const BASE_PATH = '/api/v1/mob/login';
const ADMIN_BASE_PATH = '/api/v1/mob/admin/login';
const PARTNER_BASE_PATH = '/api/v1/partner-portal/auth';

/**
 * 라이더 로그인 API
 * POST /api/v1/mob/login
 * @param params 로그인 요청 파라미터 (userId, password)
 * @returns 로그인 응답
 */
export const login = async (params: LoginRequest): Promise<LoginResponse> => {
    // POST 요청은 body로 데이터 전송 (일반적인 방식)
    const response = await apiClient.post<LoginResponse>(
        `${BASE_PATH}`,
        params  // body로 전송
    );
    return response.data;
};

/**
 * 관리자/협력사 로그인 API (앱용)
 * POST /api/v1/mob/admin/login
 * @param params 로그인 요청 파라미터 (userId, password)
 * @returns 로그인 응답
 */
export const adminLogin = async (params: LoginRequest): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse>(
        `${ADMIN_BASE_PATH}`,
        params
    );
    return response.data;
};

/**
 * 협력사 로그인 API (포털용 - 사용하지 않음)
 * POST /api/v1/partner-portal/auth/login
 */
export const supplierLogin = async (params: LoginRequest): Promise<SupplierLoginResponse> => {
    const response = await apiClient.post<SupplierLoginResponse>(
        `${PARTNER_BASE_PATH}/login`,
        params
    );
    return response.data;
};
